module.exports = __webpack_public_path__ + "assets/images/05L.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/05L.png
// module id = 1266
// module chunks = 1